import { render, staticRenderFns } from "./ImportWizard.vue?vue&type=template&id=5c98b73c&scoped=true"
import script from "./ImportWizard.vue?vue&type=script&lang=js"
export * from "./ImportWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98b73c",
  null
  
)

export default component.exports